import { LoanProductCategory } from '@appTypes/LoansApi.interface'

import { getCategoryPathForId } from './getCategoryPathForId'

/**
 * For unscored journeys, we want to use / as the alias
 * for the /all-cards route.
 *
 * @param category - The loan category
 * @returns The unscored category path
 */
export function getUnscoredCategoryPath(category: LoanProductCategory) {
    const isPersonal = category === LoanProductCategory.Personal

    return isPersonal ? '' : getCategoryPathForId(category)
}
